<template>
  <div id="selected-tariff" class="container-box tariff-container" v-show="show && tariff && hasVolumeDetails">
    <h2 class="text-3xl">Mein Tarif</h2>
    <div class="tariff-header hide-mobile" :style="{ backgroundColor: getTariffColor }">
      <div class="tariff-header-left uppercase">{{ tariff.name }}</div>
      <div class="tariff-header-right">
        <div class="data-column 1">
          <div class="value text-xl" v-if="tariff.tariffIdentifier === CLASSIC_TARIFF_ID">Datenvolumen</div>
          <div class="value text-3xl" v-else>
            {{ getVolumeDetail('PHONE', 'unit') === 'FLAT'
            ? getVolumeDetail('PHONE', 'unit')
            : getVolumeDetail('PHONE', 'amount')
            }}
            {{ getVolumeDetail('PHONE', 'unit') === 'CENT'
              ? 'Cent'
              : ''
            }}</div>
          <div class="text-sm" v-if="tariff.tariffIdentifier === CLASSIC_TARIFF_ID">flexibel zubuchbar</div>
          <div class="text-sm" v-else>{{ getVolumeDetail('PHONE', 'unit') === 'CENT'
            ? 'pro Minute und SMS'
            : 'Minuten und SMS'
            }}</div>
        </div>
        <div class="data-column 2">
          <div class="value text-xl" v-if="tariff.tariffIdentifier === CLASSIC_TARIFF_ID">Keine Mindestlaufzeit</div>
          <div class="value text-3xl" v-else>{{ getVolumeDetail('INTERNET', 'amount') }} {{ getVolumeDetail('INTERNET', 'unit') }}</div>
          <div class="text-sm" v-if="tariff.tariffIdentifier === CLASSIC_TARIFF_ID">oder Grundgebühr</div>
          <div class="text-sm" v-else>{{ getVolumeDetail('INTERNET', 'text') }}</div>
        </div>
        <div class="data-column 3" v-if="tariff && tariff.runtime">
          <div class="value text-xl" v-if="tariff.tariffIdentifier === CLASSIC_TARIFF_ID">{{getVolumeDetail('PHONE', 'amount')}} {{getVolumeDetail('PHONE', 'text')}}</div>
          <div class="value text-3xl" v-else>{{ tariff.formattedBasicFee }}</div>
          <div class="text-sm" v-if="tariff.tariffIdentifier === CLASSIC_TARIFF_ID">pro Minute und SMS</div>
          <div class="text-sm" v-else>für {{ tariff.runtime.amount }} {{ tariff.runtime.formattedUnit }}</div>
        </div>
        <button v-if="showToggleButton" class="button button--secondary" @click="toggleTariffContent">
          Tarifdetails
          <span
            class="chevron-icon"
            :class="{
              'chevron-up': isContentVisible,
              'chevron-down': !isContentVisible
            }"
            aria-hidden="true"
          >
          </span>
        </button>
        <button v-if="showPrintButton" @click="print" class="button button--secondary">
          Druckvorschau
          <span class="file-icon" aria-hidden="true"> </span>
        </button>
      </div>
    </div>

    <div class="tariff-header-mobile hide-desktop">
      <div class="tariff-header-left uppercase" v-if="tariff" :style="{ backgroundColor: getTariffColor }">
        <div class="text">{{ tariff.name }}</div>
        <div class="text-2xl text-align-center" v-if="tariff.tariffId === CLASSIC_TARIFF_ID">Datenvolumen flexibel zubuchbar</div>
        <div class="value" v-else>{{ getVolumeDetail('INTERNET', 'amount') }} {{ getVolumeDetail('INTERNET', 'unit') }}</div>
        <div class="text">{{ getVolumeDetail('INTERNET', 'text') }}</div>
      </div>
      <div class="tariff-header-right">
        <div class="data-column">
          <div class="value">
            {{ getVolumeDetail('PHONE', 'unit') === 'FLAT'
            ? getVolumeDetail('PHONE', 'unit')
            : getVolumeDetail('PHONE', 'amount')
            }}
            {{ getVolumeDetail('PHONE', 'unit') === 'CENT'
              ? 'Cent'
              : ''
            }}</div>
          <div class="text" v-if="tariff.tariffId === CLASSIC_TARIFF_ID">pro Minuten und SMS</div>
          <div class="text" v-else>Minuten und SMS</div>
          <span v-if="tariff.tariffId === CLASSIC_TARIFF_ID" class="text-base text-align-center">
          Keine Mindestlaufzeit <br>
          Keine Grundgebühr <br>
          Zahle nur, was du nutzt
        </span>
          <span v-else class="text-xl-lidl text-price">
          {{ tariff.formattedBasicFee }}
        </span>
        </div>
      </div>
      <button v-if="showToggleButton" class="button button--secondary" @click="toggleTariffContent">
        Tarifdetails
        <span
          class="chevron-icon"
          :class="{
            'chevron-up': isContentVisible,
            'chevron-down': !isContentVisible
          }"
          aria-hidden="true"
        >
        </span>
      </button>
      <button v-if="showPrintButton" @click="print" class="button button--secondary">
        Druckvorschau
        <span class="file-icon" aria-hidden="true"> </span>
      </button>
    </div>

    <template v-if="isContentVisible">
      <div class="tariff-content py-lg">
        <div class="tariff-content-left hide-mobile">
          <img class="tariff-img" src="files\lidl\images\registrierung\tariff-activation.png" alt="LIDL Connect SIM-Karte" />
        </div>
        <div class="tariff-content-right">
          <div class="list-container" v-if="tariff.advantages && tariff.advantages.length > 0">
            <div class="list-item" v-for="advantage in tariff.advantages" :key="advantage">
              <div class="list-item-icon"></div>
              <div class="list-item-text text-base">
                <span v-html="advantage"></span>
              </div>
            </div>
          </div>
          <div class="link-container">
            <a class="link text-base" :href="productData" target="_blank">
              <span>Produktinformationsblatt ansehen</span>
            </a>
            <a class="link text-base" href="https://www.lidl.de/de/asset/other/EU_TSM_Informationsblatt_neu_LC.pdf" target="_blank">
              <span>Informationsblatt zu Internetzugangsdiensten</span>
            </a>
            <a class="link text-base" :href="tariff.priceListUrl" target="_blank">
              <span>Länder-und Preistabelle ansehen</span>
            </a>
          </div>
          <button @click="selectTariff" v-show="!showToggleButton" class="button button--primary">
            {{ tariff.name }} aktivieren
          </button>
        </div>
      </div>

      <div class="tariff-content options-container py-2xl">
        <div class="tariff-content-left">
          <h2 class="text-3xl">Zubuchbare Tarifoptionen</h2>
          <div
            class="tariff-option-container"
            v-if="tariff.allTariffOptions && tariff.allTariffOptions.length > 0"
          >
            <div
              v-for="option in displayedTariffOptions"
              :key="option.tariffoptionId"
              class="tariff-option"
            >
              <template>
                <template
                  v-if="tariffOptionById[option.tariffoptionId]">
                  <h3 class="text-base-semibold">
                    {{ tariffOptionById[option.tariffoptionId].name }}
                  </h3>
                  <p class="text-base">
                    {{ tariffOptionById[option.tariffoptionId].details }}
                  </p>
                </template>
              </template>
            </div>
            <div v-if="hasMoreOptions" class="show-more-container">
              <button class="button button--text text-base-medium" @click="toggleShowMore">
                {{ showAllOptions ? 'Weniger anzeigen' : 'Mehr anzeigen' }}
                <span class="icon" :class="{ 'show-less': showAllOptions }" aria-hidden="true"></span>
              </button>
            </div>
          </div>
        </div>
        <div class="tariff-content-right">
          <div class="info-box --gray full-width">
            <h2 class="text-3xl"> {{ tariff.name }} Preisübersicht </h2>
            <div class="data-list" v-if="primaryDetails.length">
              <div class="data-item"
                   v-for="(item, idx) in primaryDetails"
                   :key="'primary-' + idx"
              >
                <div class="data-name"><span v-html="item.name"></span></div>
                <div class="data-text"><span v-html="item.text"></span></div>
              </div>
            </div>
          </div>

          <div class="info-box --gray full-width">
            <h2 class="text-3xl">Sonstiges</h2>
            <div class="data-list" v-if="additionalDetails.length">
              <div
                class="data-item"
                v-for="(item, idx) in additionalDetails"
                :key="'additional-' + idx"
              >
                <div class="data-name"><span v-html="item.name"></span></div>
                <div class="data-text"><span v-html="item.text"></span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import sheetLink from '@/mixins/sheetLink'
const CLASSIC_TARIFF_ID = '82'

export default {
  name: 'TariffDetails',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    tariff: {
      type: Object,
      required: true
    },
    extraTariffOptionsData: {
      type: Array,
      default: () => []
    },
    showToggleButton: {
      type: Boolean,
      default: false
    },
    showPrintButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showAllOptions: false,
      isContentVisible: !(this.showToggleButton || this.showPrintButton),
      CLASSIC_TARIFF_ID
    }
  },
  computed: {
    displayedTariffOptions() {
      if (!this.tariff.allTariffOptions) return []
      return this.showAllOptions ? this.tariff.allTariffOptions : this.tariff.allTariffOptions.slice(0, 4)
    },
    hasMoreOptions() {
      return this.tariff.allTariffOptions?.length > 4
    },
    getTariffColor() {
      return `var(--tariff-${this.tariff.tariffId}, var(--tariff-default))`
    },
    hasVolumeDetails() {
      return (
        this.tariff.volumeDetails &&
        (Array.isArray(this.tariff.volumeDetails)
          ? this.tariff.volumeDetails.length > 0
          : Object.keys(this.tariff.volumeDetails).length > 0)
      )
    },
    productData: function () {
      if (this.tariff.productInformation) {
        return this.sheetLink(this.tariff.productInformation.recentVersion)
      } else {
        return '#'
      }
    },
    primaryDetails() {
      const list = this.tariff.priceDetails
      if (!Array.isArray(list)) return []
      return list.filter(item => item.additional === false)
    },
    additionalDetails() {
      const list = this.tariff.priceDetails
      if (!Array.isArray(list)) return []
      return list.filter(item => item.additional === true)
    },
    tariffOptionById() {
      return this.tariff.allTariffOptions
        .reduce((map, opt) => {
          map[opt.tariffoptionId] = opt
          return map
        }, {})
    }
  },
  methods: {
    toggleShowMore() {
      this.showAllOptions = !this.showAllOptions
    },
    selectTariff() {
      this.$emit('select-tariff', this.tariff)
    },
    toggleTariffContent() {
      this.isContentVisible = !this.isContentVisible
    },
    getTariffDetail(category, type) {
      return this.tariff?.tariffExtra?.details?.[category]?.[type] || ''
    },
    print() {
      window.print()
    },
    getVolumeDetail(type, key) {
      if (!this.tariff.volumeDetails) {
        return null
      }
      const list = Array.isArray(this.tariff.volumeDetails)
        ? this.tariff.volumeDetails
        : [this.tariff.volumeDetails]

      const found = list.find(item => item.type === type)
      return found && key in found ? found[key] : null
    }
  },
  mixins: [sheetLink]
}
</script>
